import React from 'react';
import { ConfigProvider } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../../context/ThemeContext';
import { getAntdThemeConfig } from '../../utils/antdTheme';
import { SearchBarProps } from './types';
import { PLACEHOLDERS } from './constants';
import {
  FiltersContainer,
  StyledSearchInput,
} from './styles';

const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  onSearchChange,
}) => {
  const { isDarkMode } = useTheme();

  return (
    <ConfigProvider theme={getAntdThemeConfig(isDarkMode)}>
      <FiltersContainer>
        <StyledSearchInput
          {...({ $isDark: isDarkMode } as any)}
          placeholder={PLACEHOLDERS.SEARCH}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          prefix={<FontAwesomeIcon icon={faSearch} />}
          allowClear
        />
      </FiltersContainer>
    </ConfigProvider>
  );
};

export default SearchBar;
